import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setChapterSlideStep } from "../../_entities/Timeline/Timeline.actions";
import Slide from "../Slide";
import useSlider from "../../hooks/useSlider";

const Slides = ({ slides, step }) => {
  const dispatch = useDispatch();
  const dispatchSetChapterSlideStep = (step) => {
    dispatch(setChapterSlideStep(step));
  };
  const { nextSlide, slide } = useSlider(
    slides,
    step,
    dispatchSetChapterSlideStep
  );

  return (
    <>
      <Slide slide={slide} />
    </>
  );
};

export default Slides;
